import SupportCenter from '@/components/SupportCenter';
import { useApp } from '@/contexts/AppContext';
import { useTranslation } from 'react-i18next';

export default function OperatorSupport() {
  const { theme } = useApp();
  const { t } = useTranslation();
  return (
    <div className="p-4 sm:p-6">
      <SupportCenter theme={theme} t={t as unknown as ((key: string, options?: unknown) => string)} />
    </div>
  );
}
